import { render, staticRenderFns } from "./AppCharacter.vue?vue&type=template&id=b2b5b23e&scoped=true&"
import script from "./AppCharacter.vue?vue&type=script&lang=js&"
export * from "./AppCharacter.vue?vue&type=script&lang=js&"
import style0 from "./AppCharacter.vue?vue&type=style&index=0&id=b2b5b23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b5b23e",
  null
  
)

export default component.exports